import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { TabsComponentAutopass } from '../DynamicTab/tabs.componentAutopass';
import { ShareService } from '@global/shared.service';
import { NzTableComponent } from 'ng-zorro-antd/table';

import { FilterDTO } from '../model/FilterDTO';
import { switchMap, distinctUntilChanged, debounceTime, mergeMap, takeUntil ,concatMap, take } from 'rxjs/operators';
import { Subject, Subscription, Observable, forkJoin, EMPTY, of } from 'rxjs';
import { CookieService } from 'ngx-cookie';

import { ValidationService } from './service/validation-service';
import {AutopassService} from '../AutoPass/service/autopass.service';

import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators, FormArray } from '@angular/forms';
import { UserService} from '../../commonservices/user.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { FilterIdsDto } from '../rule.interface';

export interface VirtualDataInterface {
  index: number;
  name: string;
  age: number;
  address: string;
}

@Component({
  selector: 'app-validation',
  templateUrl: './validation.component.html',
  styleUrls: ['./validation.component.scss','../rule.scss']
})
export class ValidationComponent implements OnInit, AfterViewInit {

  @ViewChild('autopassform', { static: false }) autopassform;
  @ViewChild(TabsComponentAutopass, { static: false }) tabsComponent;

  private unsubscribe$ = new Subject<void>();

  clientCode: string = "";
  globalSettings: any;

  validationFilter: Array<any> = []
  
  tabs = [1, 2, 3];

  filter: FilterDTO = { 
    "Id"          : 0, 
    "Context"     : "ValidationRuel", 
    "FilterName"  : null,
    "Priority"    : 1, 
    "ClientCode"  : "", 
    "TabTitle"    : "",
    "IsChecked"   : false
  }


  searchForm: UntypedFormGroup

  clientList: Array<any> = [];
  clientDivisionList: Array<any> = [];
  clientLocationList: Array<any> = [];
  carrierScacList: Array<any> = [];
  carrrierLocationList: Array<any> = [];
  
  clientRegionList: Array<any> = [];
  clientCountryList: Array<any> = [];
  statusList: Array<any> = ['Active','Disabled'];

  @ViewChild('virtualTable', { static: false }) nzTableComponent?: NzTableComponent<VirtualDataInterface>;
  private destroy$ = new Subject();

  selectAll: boolean = false;

  constructor(
    private _sharedService: ShareService,
    private _cookieService: CookieService,
    private validationService: ValidationService,
    private _autopassService: AutopassService,
    private notificationService: NzNotificationService,
    private fb: UntypedFormBuilder,
    private cd: ChangeDetectorRef
  ) { 
    this._sharedService.clientCurrencyEmit$.pipe(
      takeUntil(this.unsubscribe$),
      distinctUntilChanged()).subscribe(data => {
          this.globalSettings = data;
          this.onChangeClient(data.client);
    });
  }
  

  ngOnInit(): void {
    this.buildForm();
    this.populate();

    of(JSON.parse(this._cookieService.get("__userSettings"))).pipe(takeUntil(this.unsubscribe$)).pipe(
      concatMap(settings => {
        this.onChangeClient(settings.WebResClientSelected);
        return this.validationService.SearchValidation(this.searchForm.value, settings.WebResClientSelected)
      })
    ).subscribe(data => {
      this.validationFilter = this.mapCheckbox(data);
    });
  }

  buildForm(){
    this.searchForm = this.fb.group({
      clientId        : null,
      client          : null,
      clientDivision  : null,
      clientLocation  : null,
      carrierScac     : null,
      carrierLocation : null,

      clientRegion    : null,
      clientCountry   : null,
      status          : null
    });
  }

  mapCheckbox(data: Array<any>){
      return data.map(x => { x.checked = false; return x;});
  }

  populate(){
    this._autopassService.GetClientId(0,0)
        .subscribe(data => this.clientList=(data));
    this._autopassService.GetClientDivision(0,0)
        .subscribe(data => this.clientDivisionList=(data));
    this._autopassService.GetClientLocation(0,0)
        .subscribe(data => this.clientLocationList=(data));
    this._autopassService.GetCarrierSCAC(0,0)
        .subscribe(data => this.carrierScacList=(data));
    this._autopassService.GetCarrierLocation(0,0)
        .subscribe(data => this.carrrierLocationList=(data));

    this._autopassService.GetCTClientCountry(0,0)
        .subscribe(data => this.clientCountryList = data);

    this._autopassService.GetClientRegionByFilter(0,0)
        .subscribe(data => this.clientRegionList = data)
  }

  public onChangeClient(clientCode: any){
    this.clientCode = clientCode;
  }

  ngAfterViewInit(): void {
    this.nzTableComponent?.cdkVirtualScrollViewport?.scrolledIndexChange
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: number) => {
        // console.log('scroll index to', data);
      });
  }

  ngOnDestroy(): void {
    // this.destroy$.next();
    this.destroy$.complete();
  }

  addFilter(){

    this.filter = { 
      "Id"          : 0, 
      "Context"     : "ValidationRule", 
      "FilterName"  : null,
      "Priority"    : 1,
      "ClientCode"  : this.clientCode, 
      "TabTitle"    : this.clientCode,
      "IsChecked"   : false
    }; 

    this.tabsComponent.openTab(
      this.clientCode,
      this.autopassform,
      this.filter, 
      true
    );
  }


  scrollToIndex(index: number): void {
    this.nzTableComponent?.cdkVirtualScrollViewport?.scrollToIndex(index);
  }

  trackByIndex(_: number, data: VirtualDataInterface): number {
    return data.index;
  }

  editFilter(e: any){
    this._autopassService.GetFilterById(e.Id).subscribe((data:FilterDTO) =>{

            this.filter = data;
            this.filter.TabTitle =  `${this.filter.Id} - ${this.filter.FilterName}`;

            this.tabsComponent.openTab(
              this.filter.TabTitle,
              this.autopassform,
              this.filter,
              true
            );
        });
  }

  closeAllTabsEmit(data: any){
    this.validationService.SearchValidation(this.searchForm.value, this.clientCode).subscribe(filter =>{
      this.validationFilter = this.mapCheckbox(filter);   
    });
  }

  
  addTagFn(name){
    return name;
  }

  search(){
    this.validationService.SearchValidation(this.searchForm.value, this.clientCode).subscribe(data => {
        this.validationFilter = data.length > 0 ? this.mapCheckbox(data) : [];
    });
  }

  clear(){
    this.searchForm.reset();
  }

  removeFilter(id: number){
    this.validationFilter.forEach((item, index) => {
      if(item.Id === id) this.validationFilter.splice(index,1);
    });
 }

  deleteFilter(): void{    
    var ids: FilterIdsDto = {
      FilterIds: this.validationFilter.filter(x => x.checked).map(x => x.Id)
    }

    this.validationService.DeleteFilterIds(ids).subscribe( data => {
      this.createNotification('success','Deleted',`Filters successfully removed`);
      ids.FilterIds.forEach(x => this.removeFilter(x))
      this.validationFilter = [...this.validationFilter]
    })
  }

  createNotification(type: string, title: string, message: string, durationBySeconds: number = 5): void {   
    this.notificationService.create(
      type,
      title,
      message,
      {
        nzDuration: durationBySeconds * 1000
      }
    );
  }

  selectAllChange(event :any){
    this.validationFilter.forEach(x => x.checked = event);
  }

}
